import { render, staticRenderFns } from "./UserOrientations.vue?vue&type=template&id=63c36625&scoped=true"
import script from "./UserOrientations.vue?vue&type=script&lang=js"
export * from "./UserOrientations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c36625",
  null
  
)

export default component.exports